import RegularUserSee from './RegularUserSee';

export default RegularUserSee;
